import SearchResult, { SearchResultItem } from '../models/SearchResult';
import FAQArticle from '../../../faq/src/models/FAQArticle';

export default class SearchResultMapper {
    public static map(data: any) : SearchResult {
        const result = new SearchResult();
        result.totalNumberOfSearchResults = data.TotalNumberOfSearchResults;
        result.page = data.Page;
        result.searchResults = data.SearchResults?.map((item: any) => this.mapItem(item));
        result.faqs = data.Faqs?.map((faq: any) => new FAQArticle({ question: faq.Question, answer: faq.Answer}));

        return result;
    }

    private static mapItem(data: any) : SearchResultItem {
        const model = new SearchResultItem();
        model.title = data.Title;
        model.content = data.Content;
        model.type = data.Type;
        model.url = data.Url;
        model.score = data.Score;

        return model;
    }
}